import { downloadBlob } from '@mint-lib/api-zod-support';
import { useTranslation } from '@mint-lib/i18n';
import { enqueueSnackbar } from '@mint-lib/notifications';
import { useMutation } from '@mint-lib/query-client';
import { useInstance } from '@mint-lib/routing-context';

export const useImportTemplate = () => {
  const { t } = useTranslation('@myn/planning_v2');
  const [http] = useInstance('http', 'defaultApi');

  return useMutation({
    mutationFn: async (activityId: string | number) => {
      // TODO: PDT-95897 Refactor after declareStream returns headers to extract filename from Content-Disposition
      const response = await http?.request({
        url: `api/planning-service/activities/${activityId}/import/xlsx/template/`,
        method: 'GET',

        // @ts-expect-error TS2339 There is issue with blob file and dataToCamelCase interceptor
        clientOptions: {
          response: {
            camelCaseBody: false,
          },
        },
        responseType: 'blob',
      });

      if (response?.status !== 200) {
        throw new Error('Failed to fetch import template');
      }

      const disposition = response.headers['content-disposition'];

      const fileName = disposition?.match(/filename="?([^"]+)"?/)?.[1];

      const blob = new Blob([response?.data]);

      return {
        blob,
        fileName,
      };
    },
    onSuccess: (response) => {
      downloadBlob(response.blob, response.fileName);
    },
    onError: () => {
      enqueueSnackbar({
        title: t('Something went wrong'),
        subTitle: t('Failed to get import template'),
        variant: 'error',
        removable: true,
      });
    },
  });
};
